import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  status: null,
};

// Slice
const googleAnaliticsSlice = createSlice({
  name: "googleAnalitics",
  initialState,
  reducers: {
    initGA() {
      return {
        status: null,
      };
    },
    setGA(state, action) {
      const { status } = action.payload;
      return {
        ...state,
        status,
      };
    },
  },
});

export const { initGA, setGA } = googleAnaliticsSlice.actions;

export default googleAnaliticsSlice.reducer;
